/* eslint-disable @typescript-eslint/ban-types */

import { Title } from "../modules/entities/Entities";

export function mapObject<TInput extends Object, TOutput>(input: TInput, mapFn: (value: TInput) => TOutput): TOutput;
export function mapObject<TInput extends Object, TOutput>(
  input: TInput | undefined,
  mapFn: (value: TInput) => TOutput,
): TOutput | undefined;
export function mapObject<TInput extends Object, TOutput>(
  input: TInput | undefined,
  mapFn?: (value: TInput) => TOutput,
): TInput | undefined;
export function mapObject<TInput extends Object, TOutput>(
  input: TInput | undefined,
  mapFn?: (value: TInput) => TOutput,
): TOutput | TInput | undefined {
  if (!input) {
    return undefined;
  }

  if (!mapFn) {
    return input;
  }

  return mapFn(input);
}

const TITLE_MAP: Record<string, Title> = {
  mr: Title.Mr,
  mrs: Title.Mrs,
  miss: Title.Miss,
  ms: Title.Ms,
  dr: Title.Dr,
  prof: Title.Prof,
  adv: Title.Adv,
  rev: Title.Rev,
  hon: Title.Hon,
  me: Title.Me,
  mev: Title.Mev,
  mej: Title.Mej,
  mnr: Title.Mnr,
};

export function mapTitle(value?: string | null): Title {
  if (!value) return Title.Dr;

  return TITLE_MAP[value.trim().toLowerCase()] ?? Title.Dr;
}
